module.exports = __webpack_public_path__ + "static/media/PENTIUM.8fbb0146.jpg";